import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Creates a URL safely, handling relative URLs by adding the base origin
 */
export function createSafeUrl(url: string, base?: string): string {
  try {
    // If it's already an absolute URL, just use it
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // For relative URLs, use the current origin as base if not provided
    const baseUrl = base || (typeof window !== 'undefined' ? window.location.origin : '');
    
    // Handle leading slash
    const path = url.startsWith('/') ? url : `/${url}`;
    
    // Combine base and path
    return `${baseUrl}${path}`;
  } catch (error) {
    console.error('Error creating URL:', error);
    // Fallback to simple string concatenation
    const baseUrl = base || (typeof window !== 'undefined' ? window.location.origin : '');
    const path = url.startsWith('/') ? url : `/${url}`;
    return `${baseUrl}${path}`;
  }
}
